import i18n from '../i18n/i18n'
import { z } from 'zod'

z.setErrorMap((issue) => {
  const t = i18n.t.bind(i18n)

  switch (issue.code) {
    case 'too_small':
      if (issue.type === 'string') {
        return { message: t('validation:string.min', { min: issue.minimum }) }
      }
      return { message: t('validation:number.min', { min: issue.minimum }) }
    case 'too_big':
      if (issue.type === 'string') {
        return { message: t('validation:string.max', { max: issue.maximum }) }
      }
      return { message: t('validation:number.max', { max: issue.maximum }) }
    case 'invalid_type':
      return { message: t('validation:required') }
    case 'invalid_format':
      if (issue.format === 'email') {
        return { message: t('validation:email') }
      }
      return { message: t('validation:invalid_type') }
    default:
      return null
  }
})
